import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledColumnHeader = styled.div`
  color: ${themeGet('color.colorGrayBlue90')};
  margin-bottom: ${themeGet('scale.scaleUp03')};

  h4 {
    font-size: ${themeGet('scale.scaleDown01')};
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: ${themeGet('scale.scaleDown01')};
  }

  p {
    font-size: ${themeGet('scale.scaleBase')};
    padding-bottom: ${themeGet('scale.scaleUp03')};
    margin-bottom: 0;
    border-bottom: 1px solid ${themeGet('color.colorGrayBlue40')};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  a:hover,
  &.is-active a {
    text-decoration: underline;
    color: inherit;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    margin-bottom: ${themeGet('scale.scaleUp05')};
  }
`;

export default StyledColumnHeader;
